import { MyTypo } from "../../utils/typography/typographier";

function CardMobile1({ yoga }) {
  return (
    <div className="cardPrimary">
      <div className="cardPrimary-containerContains">
        <div className="cardPrimary-containerContains-paragraph">
          <div className="cardPrimary-containerContains-paragraph-paragraphFirst">
            <p id="text-yoga">{MyTypo(yoga.description1)}</p>
          </div>
          <div className="cardPrimary-containerContains-paragraph-paragraphSecond">
            <p id="text-yoga">{MyTypo(yoga.description2)}</p>
          </div>
        </div>
        <div className="cardPrimary-containerContains-container">
          <div className="cardPrimary-containerContains-container-img">
            <picture>
              <source media="(min-width: 1024px)" srcSet={yoga.coverDesktopL} type="image/webp" />
              <img src={yoga.coverMobile} alt={yoga.alt} />
            </picture>
          </div>
        </div>
      </div>
      <div className="cardPrimary-containerBackground"></div>
    </div>
  );
}

export default CardMobile1;
